import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  touchBlocker: {
    ...StyleSheet.absoluteFillObject,
  },
  drawer: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: colors.white,
    padding: theme.spacings.md,
    elevation: 10,
    shadowColor: colors.newUI.therapist.shadow,
    shadowOffset: { width: -11, height: 0 },
    shadowOpacity: 0.15,
    shadowRadius: 26,
  },
  headerContainer: {
    paddingHorizontal: theme.spacings.lg,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleRow: {
    gap: theme.spacings.sm,
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    fontSize: theme.fontSizes.lg,
    fontWeight: '600',
    marginVertical: theme.spacings.sm,
  },
  headerDivider: {
    paddingVertical: theme.spacings.lg,
  },
  footer: {
    paddingHorizontal: theme.spacings.lg,
    flexDirection: 'row',
    gap: theme.spacings.sm,
    marginBottom: theme.spacings.lg,
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  button: {
    alignSelf: 'flex-start',
  },
});
